import { render, staticRenderFns } from "./ModalHistoricoSuporte.vue?vue&type=template&id=4426f6f2&"
import script from "./ModalHistoricoSuporte.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricoSuporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports